import React, { Component } from 'react';
import './../../styles/alert-message.css';

class Alert extends Component {
    
      componentDidMount() {
        if (this.props.onClose) {
        this.timer = setTimeout(() => { console.log('close message'); this.props.onClose()},     
          this.props.timeout );
        }
      }
      
      componentWillUnmount() {
        clearTimeout(this.timer);
      }
      
      alertClass (type) {
        let classes = {
          error: 'alert alert-danger',
          success: 'alert alert-success'
        };
        return classes[type] || classes.success;
      }
      
      render() {
        const message = this.props.message;
        const alertClassName = this.alertClass(message.type);
     
        return(
            <div className={ alertClassName} role="alert">
              { message.text }
            </div>
        );
      }
    }

export default  Alert;  

    Alert.defaultProps = {
        timeout: 3000
    }


// WEBPACK FOOTER //
// ./src/components/Alert/Alert.js